import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { FcmNotification } from "./../../../models/common";
import { Component, Inject, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Observable, Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { COUNTRY_CODES } from "../../data/country-codes";
import { EmployeeAssignForServiceComponent } from "../employee-assign-for-service/employee-assign-for-service.component";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "src/app/providers/auth.service";
import { InvoiceForAdvanceComponent } from "../invoice-for-advance/invoice-for-advance.component";
@Component({
  selector: "sm-manage-booking",
  templateUrl: "./manage-booking.component.html",
  styleUrls: ["./manage-booking.component.scss"],
})
export class ManageBookingComponent implements OnInit, OnDestroy {
  isOwner: boolean = false;

  taxSlabData: any = [];
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  productsList: any = [];
  form: FormGroup;
  private _apiSubscription: Subscription = new Subscription();
  public newbookingData: any = {
    price: 0,
  };
  selectedBookingType: number = 1;
  serviceList: any = [];
  discountInfo: any = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private http: HttpClient,
    private fb: FormBuilder,
    private _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private ngzone: NgZone,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) {
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
  }
  advancePaymentSettings: any = null;

  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    if (sessionStorage.getItem(SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS)) {
      this.advancePaymentSettings =
        typeof sessionStorage.getItem(
          SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
        ) == "string"
          ? JSON.parse(
              sessionStorage.getItem(
                SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
              )!
            )
          : sessionStorage.getItem(
              SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
            );
    }
    console.log(this.parentData.data);
    this.discountInfo = this.parentData.data.discountInfo;
    let data = this.parentData.data;
    this.newbookingData.customerName =
      data.bookingData.customerInfo.name &&
      data.bookingData.customerInfo.name != "null" &&
      data.bookingData.customerInfo.name != ""
        ? data.bookingData.customerInfo.name
        : "";
    // this.newbookingData.customerPh  =   (data.bookingData.customerInfo.phone && data.bookingData.customerInfo.phone != 'null' && data.bookingData.customerInfo.phone != '') ? data.bookingData.customerInfo.phone.slice(3) : ''
    this.newbookingData.customerPh = data.bookingData.customer_phone;

    this.selectedCountryCode = this.countryList.find(
      (country) => country.dial_code === data.bookingData.country_code
    );
    this.newbookingData.note =
      data.bookingData.note &&
      data.bookingData.note != "null" &&
      data.bookingData.note != ""
        ? data.bookingData.note
        : "";

    if (this.isEntityForeign == "0") {
      this._apiService.getEntityTaxSlabData(data.entityHash);
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash);
    }

    this._apiService.getServicesTypesList(data.eph, "0", "0");
    this._apiService.getEntityProductList(data.entityHash, "1");

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inManageBookings:", resData);
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resData);

        this.serviceList = [];
        if (this.parentData.data.serviceType == "1") {
          resData.result.forEach((element: any) => {
            if (element.shopStatus == 1 && element.status == 1) {
              element.toShow = true;
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
        } else if (this.parentData.data.serviceType == "0") {
          resData.result.forEach((element: any) => {
            if (element.homeStatus == 1 && element.status == 1) {
              element.toShow = true;
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
        } else if (this.parentData.data.serviceType == "2") {
          resData.result.forEach((element: any) => {
            if (element.for_virtual == 1 && element.status == 1) {
              element.toShow = true;
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
        }

        if (data.bookingData.serviceInfo) {
          data.bookingData.serviceInfo.forEach((element: any) => {
            if (element.completed_by && element.completed_by != "null") {
              let total_completed = 0;
              element.completed_by.forEach((item: any) => {
                total_completed += item.competed_services_qty;
              });

              element.total_completed_services_qty = total_completed;
              this.selectServices(element);
            }
            // if(element.current_status == 3){
            // }
          });
        }

        if (data.bookingData.custom_items) {
          data.bookingData.custom_items.forEach((element: any) => {
            if (element) {
              this.items.push(this.createFieldWithItem(element));
            }
            // if(element.current_status == 3){
            // }
          });
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resData);

        this.productsList = [];
        if (resData.result) {
          if (this.parentData.data.serviceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.parentData.data.serviceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.parentData.data.serviceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }

          if (data.bookingData.appointment_products) {
            data.bookingData.appointment_products.forEach((element: any) => {
              this.selectProducts(element);
              // if(element.completed_by && element.completed_by != 'null'){
              //   let total_completed = 0
              //   element.completed_by.forEach((item:any) => {
              //     total_completed += item.competed_services_qty
              //   });

              //   element.total_completed_services_qty = total_completed
              // }
              // if(element.current_status == 3){
              // }
            });
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        if (resData.result) {
            if (this.parentData.data.bookingData.customerPayment && this.parentData.data.bookingData.customerPayment > 0) {
              if (this.isEntityForeign == "0") {
                  let bodyData = [
                    {
                      appointment_hash_id: JSON.parse(resData.result)
                        .bookingHashId,
                      is_primary: 1,
                      creation_date: this.formatDateString(
                        this.parentData.datetime
                          ? this.parentData.datetime
                          : new Date()
                      ),
                    },
                  ];
                  this._apiService.addEditEntityAdvanceInvoice(bodyData);
                } else if (this.isEntityForeign == "1") {
                  let bodyData = [
                    {
                      appointment_hash_id: JSON.parse(resData.result)
                        .bookingHashId,
                      is_primary: 1,
                      creation_date: this.formatDateString(
                        this.parentData.datetime
                          ? this.parentData.datetime
                          : new Date()
                      ),
                    },
                  ];
                  this._apiService.addEditInternationalEntityAdvanceInvoice(
                    bodyData
                  );
                }
            } else {
              this.parentData.ref.closeAll();
            }
         
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_ADVANCE_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_ADVANCE_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();
          if (this.parentData.data.bookingData.customerPayment && this.parentData.data.bookingData.customerPayment > 0) {
              this._modelRef.open(InvoiceForAdvanceComponent, {
                width: "510px",
                data: {
                  title: "Invoice",
                  ref: this._modelRef,
                  showmerge: 1,
                  force: 1,
                  data: JSON.parse(resData.result).bookingHashId,
                },
              });
          } else {
            this._modelRef.open(InvoiceComponent, {
              width: "510px",
              data: {
                title: "Invoice",
                ref: this._modelRef,
                showmerge: 1,
                data: JSON.parse(resData.result).bookingHashId,
              },
            });
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
    });
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
  decreaseServiceCount(item: any, index: any) {
    if (this.completedJobs[index].total_completed_services_qty == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.parentData.data.serviceType == "0") {
        if (this.completedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.completedJobs[index].homeDiscountedPrice;
        } else if (this.completedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.completedJobs[index].home_rate;
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.completedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.completedJobs[index].shopDiscountedPrice;
        } else if (this.completedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.completedJobs[index].shop_rate;
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.completedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.completedJobs[index].virtual_discounted_amount;
        } else if (this.completedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.completedJobs[index].virtual_rate;
        }
      }

      this.serviceList[index1].toShow = true;
      this.completedJobs.splice(index, 1);
    } else {
      this.completedJobs[index].total_completed_services_qty--;

      const index1 = item.completed_by.findIndex(
        (x: any) =>
          x.completed_by_hash ==
          localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)
      );
      console.log(index1);

      // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);
      let service_cost;
      if (this.parentData.data.serviceType == "0") {
        if (this.completedJobs[index].discountStatus == 1) {
          service_cost = this.completedJobs[index].homeDiscountedPrice;
          // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
        } else if (this.completedJobs[index].discountStatus == 0) {
          service_cost = this.completedJobs[index].home_rate;
          // this.newbookingData.price += this.completedJobs[index].home_rate
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.completedJobs[index].discountStatus == 1) {
          service_cost = this.completedJobs[index].shopDiscountedPrice;
          // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
        } else if (this.completedJobs[index].discountStatus == 0) {
          service_cost = this.completedJobs[index].shop_rate;
          // this.newbookingData.price += this.completedJobs[index].shop_rate
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.completedJobs[index].discountStatus == 1) {
          service_cost = this.completedJobs[index].virtual_discounted_amount;
          // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
        } else if (this.completedJobs[index].discountStatus == 0) {
          service_cost = this.completedJobs[index].virtual_rate;
          // this.newbookingData.price += this.completedJobs[index].shop_rate
        }
      }
      this.newbookingData.price -= service_cost;
      if (index1 == -1) {
        if (
          item.completed_by[item.completed_by.length - 1]
            .competed_services_qty == 1
        ) {
          item.completed_by.splice(item.completed_by.length - 1, 1);
        } else {
          item.completed_by[item.completed_by.length - 1]
            .competed_services_qty--;
          item.completed_by[item.completed_by.length - 1].cost -= service_cost;
        }
        // item.completed_by.splice(item.completed_by.length-1,1)
      } else {
        if (item.completed_by[index1].competed_services_qty == 1) {
          item.completed_by.splice(index1, 1);
        } else {
          item.completed_by[index1].cost -= service_cost;
          item.completed_by[index1].competed_services_qty -= 1;
        }
      }

      console.log(item);
    }
  }
  increaseServiceCount(item: any, index: any) {
    this.completedJobs[index].total_completed_services_qty++;

    const index1 = item.completed_by.findIndex(
      (x: any) =>
        x.completed_by_hash ==
        localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)
    );
    console.log(index1);

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);
    let service_cost;
    if (this.parentData.data.serviceType == "0") {
      if (this.completedJobs[index].discountStatus == 1) {
        service_cost = this.completedJobs[index].homeDiscountedPrice;
        // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
      } else if (this.completedJobs[index].discountStatus == 0) {
        service_cost = this.completedJobs[index].home_rate;
        // this.newbookingData.price += this.completedJobs[index].home_rate
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.completedJobs[index].discountStatus == 1) {
        service_cost = this.completedJobs[index].shopDiscountedPrice;
        // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
      } else if (this.completedJobs[index].discountStatus == 0) {
        service_cost = this.completedJobs[index].shop_rate;
        // this.newbookingData.price += this.completedJobs[index].shop_rate
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.completedJobs[index].discountStatus == 1) {
        service_cost = this.completedJobs[index].virtual_discounted_amount;
        // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
      } else if (this.completedJobs[index].discountStatus == 0) {
        service_cost = this.completedJobs[index].virtual_rate;
        // this.newbookingData.price += this.completedJobs[index].shop_rate
      }
    }
    this.newbookingData.price += service_cost;
    if (index1 == -1) {
      item.completed_by.push({
        cost: service_cost,
        employee_name:
          localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + "(Owner)",
        completed_by_hash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        competed_services_qty: 1,
      });
    } else {
      item.completed_by[index1].cost += service_cost;
      item.completed_by[index1].competed_services_qty += 1;
    }
  }
  decreaseProductCount(item: any, index: any) {
    console.log(item);

    if (this.completedProducts[index].product_qty == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.completedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.parentData.data.serviceType == "0") {
        if (this.completedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.completedProducts[index].home_discounted_price;
        } else if (this.completedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.completedProducts[index].home_price;
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.completedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.completedProducts[index].shop_discounted_price;
        } else if (this.completedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.completedProducts[index].shop_rate;
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.completedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.completedProducts[index].virtual_discounted_price;
        } else if (this.completedProducts[index].discount_status == 0) {
          this.newbookingData.price -=
            this.completedProducts[index].virtual_rate;
        }
      }

      this.productsList[index1].toShow = true;
      this.completedProducts.splice(index, 1);
    } else {
      this.completedProducts[index].product_qty--;

      // const index1 = item.completed_by.findIndex( (x:any)=> x.completed_by_hash == localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID));
      // console.log(index1);

      // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      // const index1 = this.completedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);
      let service_cost;
      if (this.parentData.data.serviceType == "0") {
        if (this.completedProducts[index].discount_status == 1) {
          service_cost = this.completedProducts[index].home_discounted_price;
          // this.newbookingData.price += this.completedProducts[index].home_discounted_price
        } else if (this.completedProducts[index].discount_status == 0) {
          service_cost = this.completedProducts[index].home_price;
          // this.newbookingData.price += this.completedProducts[index].home_price
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.completedProducts[index].discount_status == 1) {
          service_cost = this.completedProducts[index].shop_discounted_price;
          // this.newbookingData.price += this.completedProducts[index].shop_discounted_price
        } else if (this.completedProducts[index].discount_status == 0) {
          service_cost = this.completedProducts[index].shop_price;
          // this.newbookingData.price += this.completedProducts[index].shop_price
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.completedProducts[index].discount_status == 1) {
          service_cost = this.completedProducts[index].virtual_discounted_price;
          // this.newbookingData.price += this.completedProducts[index].shop_discounted_price
        } else if (this.completedProducts[index].discount_status == 0) {
          service_cost = this.completedProducts[index].virtual_price;
          // this.newbookingData.price += this.completedProducts[index].shop_price
        }
      }
      this.newbookingData.price -= service_cost;

      console.log(item);
    }
  }
  increaseProductCount(item: any, index: any) {
    this.completedProducts[index].product_qty++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.completedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);
    let service_cost;
    if (this.parentData.data.serviceType == "0") {
      if (this.completedProducts[index].discount_status == 1) {
        service_cost = this.completedProducts[index].home_discounted_price;
        // this.newbookingData.price += this.completedProducts[index].home_discounted_price
      } else if (this.completedProducts[index].discount_status == 0) {
        service_cost = this.completedProducts[index].home_price;
        // this.newbookingData.price += this.completedProducts[index].home_rate
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.completedProducts[index].discount_status == 1) {
        service_cost = this.completedProducts[index].shop_discounted_price;
        // this.newbookingData.price += this.completedProducts[index].shop_discounted_price
      } else if (this.completedProducts[index].discount_status == 0) {
        service_cost = this.completedProducts[index].shop_price;
        // this.newbookingData.price += this.completedProducts[index].shop_price
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.completedProducts[index].discount_status == 1) {
        service_cost = this.completedProducts[index].virtual_discounted_price;
        // this.newbookingData.price += this.completedProducts[index].shopDiscountedPrice
      } else if (this.completedProducts[index].discount_status == 0) {
        service_cost = this.completedProducts[index].virtual_price;
        // this.newbookingData.price += this.completedJobs[index].shop_rate
      }
    }
    this.newbookingData.price += service_cost;
  }

  formChecker() {
    if (this.newbookingData.customerPh) {
      if (
        this.newbookingData.customerPh.length >= 3 &&
        this.newbookingData.customerPh.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  serviceInfo: any = [];
  onPost() {
    if (this.completedJobs.length == 0) {
      this.snackBar.open("Add service info to continue", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.formChecker()) {
      this.snackBar.open("Enter valid phone number", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.form.invalid) {
      this.snackBar.open("Fill up all required fields of custom items", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.productInfo = [];
      this.completedJobs.forEach((element: any) => {
        const totalQty = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.competed_services_qty,
          0
        );
        const serviceCost = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.cost,
          0
        );
        this.completedServices.push({
          service_hash_id: element.hash_id,
          service_name: element.serviceName,
          description: element.description,
          img_url: element.imgUrl,
          approxTime: element.approxTime,
          completed_by_hash_id: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          service_cost: serviceCost,
          current_status: 3,
          completed_by_hash_ids: element.completed_by.map((data: any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost,
            };
          }),
          serviceQty: totalQty,
        });
      });

      this.productInfo = this.completedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.product_desc,
          entity_product_hash: item.hash_id,
          product_img_url: item.thumb_image_url,
          product_price:
            this.parentData.data.serviceType == "0"
              ? item.discount_status == 1
                ? item.home_discounted_price
                : item.home_price * item.product_qty
              : this.parentData.data.serviceType == "1"
              ? item.discount_status == 1
                ? item.shop_discounted_price
                : item.shop_price * item.product_qty
              : item.discount_status == 1
              ? item.virtual_discounted_price
              : item.virtual_price * item.product_qty,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.product_qty * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.product_qty) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let applicableDiscount = 0;
      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }

      let data = {
        bookingStatusInfo: {
          appointmentHash: this.parentData.data.bookingData.hash_id,
          assignedToHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          assignedByHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          entityHash: this.parentData.data.entityHash,
          bookingStatus: 4,
          price: this.newbookingData.price.toString(),
          startTime: this.parentData.data.bookingData.bookingStartTime.slice(
            0,
            5
          ),
          endTime: this.formatTime(new Date()),
          note: this.newbookingData.note,
          completedServices: this.completedServices,
          products: this.productInfo,
          custom_items: this.form.get("items")!.value.map((item: any) => {
            return {
              item_name: item.name.item_name ? item.name.item_name : item.name,
              item_desc: item.name.item_desc ?? "",
              item_inventory_hash: item.name.hash_id ?? "",
              item_img_url: item.name.image_thumb_url ?? "",
              item_qty: item.count,
              item_price: +item.price,
              tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
            };
          }),
          bookingDate: this.formatDateString(
            new Date(this.parentData.data.bookingData.bookingDate)
          ),
          countryCode: this.selectedCountryCode.dial_code,
          customerPh: this.newbookingData.customerPh
            ? this.newbookingData.customerPh
            : "0000000000",
          customerName: this.newbookingData.customerName,
          bookingType: this.parentData.data.serviceType,
          customerHash: this.parentData.data.bookingData.customerInfo.hash_id,
          discount: +applicableDiscount.toFixed(2),
        },
      };
      Object.keys(data.bookingStatusInfo).forEach((key) => {
        if ((data.bookingStatusInfo as any)[key] === null) {
          delete (data.bookingStatusInfo as any)[key];
        }
      });
      data.bookingStatusInfo.completedServices.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      console.log(data);
      this.loader.showLoader = true;
      this._apiService.updateBookingStatusWithInvoice(data);
    }
  }

  completedServices: any = [];
  productInfo: any = [];
  partiallyDone() {
    if (this.completedJobs.length == 0) {
      this.snackBar.open("Add service info to continue", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.formChecker()) {
      this.snackBar.open("Enter valid phone number", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.form.invalid) {
      this.snackBar.open("Fill up all required fields of custom items", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.completedServices = [];
      this.productInfo = [];
      this.completedJobs.forEach((element: any) => {
        const totalQty = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.competed_services_qty,
          0
        );
        const serviceCost = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.cost,
          0
        );
        this.completedServices.push({
          service_hash_id: element.hash_id,
          service_name: element.serviceName,
          description: element.description,
          img_url: element.imgUrl,
          approxTime: element.approxTime,
          completed_by_hash_ids: element.completed_by.map((data: any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost,
            };
          }),
          service_cost: serviceCost,
          current_status: 3,
          serviceQty: totalQty,
          tax_slab_hash: element.tax_slab_hash,
          service_sac_code: element.service_sac_code,
        });
      });

      this.productInfo = this.completedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.product_desc,
          entity_product_hash: item.hash_id,
          product_img_url: item.thumb_image_url,
          product_price:
            this.parentData.data.serviceType == "0"
              ? item.discount_status == 1
                ? item.home_discounted_price
                : item.home_price * item.product_qty
              : this.parentData.data.serviceType == "1"
              ? item.discount_status == 1
                ? item.shop_discounted_price
                : item.shop_price * item.product_qty
              : item.discount_status == 1
              ? item.virtual_discounted_price
              : item.virtual_price * item.product_qty,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.product_qty * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.product_qty) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let applicableDiscount = 0;
      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }

      let data = {
        bookingStatusInfo: {
          appointmentHash: this.parentData.data.bookingData.hash_id,
          assignedToHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          bookingType: this.parentData.data.serviceType,
          assignedByHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          entityHash: this.parentData.data.entityHash,
          bookingStatus: 9,
          price:
            this.newbookingData.price < this.parentData.data.bookingData.price
              ? this.parentData.data.bookingData.price.toString()
              : this.newbookingData.price.toString(),
          startTime: this.parentData.data.bookingData.bookingStartTime.slice(
            0,
            5
          ),
          endTime: this.parentData.data.bookingData.bookingEndTime.slice(0, 5),
          note: this.newbookingData.note,
          countryCode: this.selectedCountryCode.dial_code,
          customerPh: this.newbookingData.customerPh
            ? this.newbookingData.customerPh
            : "0000000000",
          customerName: this.newbookingData.customerName,
          completedServices: this.completedServices,
          products: this.productInfo,
          custom_items: this.form.get("items")!.value.map((item: any) => {
            return {
              item_name: item.name.item_name ? item.name.item_name : item.name,
              item_desc: item.name.item_desc ?? "",
              item_inventory_hash: item.name.hash_id ?? "",
              item_img_url: item.name.image_thumb_url ?? "",
              item_qty: item.count,
              item_price: +item.price,
              tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
            };
          }),
          bookingDate: this.formatDateString(
            new Date(this.parentData.data.bookingData.bookingDate)
          ),
          customerHash: this.parentData.data.bookingData.customerInfo.hash_id,
          discount: +applicableDiscount.toFixed(2),
        },
      };

      Object.keys(data.bookingStatusInfo).forEach((key) => {
        if ((data.bookingStatusInfo as any)[key] === null) {
          delete (data.bookingStatusInfo as any)[key];
        }
      });
      data.bookingStatusInfo.completedServices.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });

      console.log(data);
      this.loader.showLoader = true;
      this._apiService.updateBookingStatus(data);
    }
  }

  allDoneAndRelease() {
    if (this.completedJobs.length == 0) {
      this.snackBar.open("Add service info to continue", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.formChecker()) {
      this.snackBar.open("Enter valid phone number", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.form.invalid) {
      this.snackBar.open("Fill up all required fields of custom items", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.completedServices = [];
      this.productInfo = [];
      this.completedJobs.forEach((element: any) => {
        const totalQty = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.competed_services_qty,
          0
        );
        const serviceCost = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.cost,
          0
        );
        this.completedServices.push({
          service_hash_id: element.hash_id,
          service_name: element.serviceName,
          description: element.description,
          img_url: element.imgUrl,
          approxTime: element.approxTime,
          completed_by_hash_ids: element.completed_by.map((data: any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost,
            };
          }),
          service_cost: serviceCost,
          current_status: 3,
          serviceQty: totalQty,
          tax_slab_hash: element.tax_slab_hash,
          service_sac_code: element.service_sac_code,
        });
      });

      this.productInfo = this.completedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.product_desc,
          entity_product_hash: item.hash_id,
          product_img_url: item.thumb_image_url,
          product_price:
            this.parentData.data.serviceType == "0"
              ? item.discount_status == 1
                ? item.home_discounted_price
                : item.home_price * item.product_qty
              : this.parentData.data.serviceType == "1"
              ? item.discount_status == 1
                ? item.shop_discounted_price
                : item.shop_price * item.product_qty
              : item.discount_status == 1
              ? item.virtual_discounted_price
              : item.virtual_price * item.product_qty,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.product_qty * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.product_qty) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let applicableDiscount = 0;
      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }
      let data = {
        bookingStatusInfo: {
          appointmentHash: this.parentData.data.bookingData.hash_id,
          assignedToHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          bookingType: this.parentData.data.serviceType,
          assignedByHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          entityHash: this.parentData.data.entityHash,
          bookingStatus: 4,
          price: this.newbookingData.price.toString(),
          startTime: this.parentData.data.bookingData.bookingStartTime.slice(
            0,
            5
          ),
          endTime: this.parentData.data.bookingData.bookingEndTime.slice(0, 5),
          note: this.newbookingData.note,
          countryCode: this.selectedCountryCode.dial_code,
          customerPh: this.newbookingData.customerPh
            ? this.newbookingData.customerPh
            : "0000000000",
          customerName: this.newbookingData.customerName,
          completedServices: this.completedServices,
          products: this.productInfo,
          custom_items: this.form.get("items")!.value.map((item: any) => {
            return {
              item_name: item.name.item_name ? item.name.item_name : item.name,
              item_desc: item.name.item_desc ?? "",
              item_inventory_hash: item.name.hash_id ?? "",
              item_img_url: item.name.image_thumb_url ?? "",
              item_qty: item.count,
              item_price: +item.price,
              tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
            };
          }),
          bookingDate: this.formatDateString(
            new Date(this.parentData.data.bookingData.bookingDate)
          ),
          customerHash: this.parentData.data.bookingData.customerInfo.hash_id,
          discount: +applicableDiscount.toFixed(2),
        },
      };

      Object.keys(data.bookingStatusInfo).forEach((key) => {
        if ((data.bookingStatusInfo as any)[key] === null) {
          delete (data.bookingStatusInfo as any)[key];
        }
      });
      data.bookingStatusInfo.completedServices.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });

      console.log(data);
      this.loader.showLoader = true;
      this._apiService.updateBookingStatus(data);
    }
  }

  changeChip(value: number) {
    this.selectedBookingType = value;
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }
  completedJobs: any = [];
  selectServices(item: any) {
    console.log(item);
    if (item.serviceTypeHash) {
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.serviceTypeHash
      );
      if (index != -1) {
        this.serviceList[index].current_status = 3;
        this.serviceList[index].total_completed_services_qty =
          item.total_completed_services_qty;
        this.serviceList[index].completed_by = item.completed_by;
        this.completedJobs.push(this.serviceList[index]);

        if (this.parentData.data.serviceType == "0") {
          if (this.serviceList[index].discountStatus == 1) {
            this.newbookingData.price +=
              this.serviceList[index].homeDiscountedPrice *
              item.total_completed_services_qty;
          } else if (this.serviceList[index].discountStatus == 0) {
            this.newbookingData.price +=
              this.serviceList[index].home_rate *
              item.total_completed_services_qty;
          }
        } else if (this.parentData.data.serviceType == "1") {
          if (this.serviceList[index].discountStatus == 1) {
            this.newbookingData.price +=
              this.serviceList[index].shopDiscountedPrice *
              item.total_completed_services_qty;
          } else if (this.serviceList[index].discountStatus == 0) {
            this.newbookingData.price +=
              this.serviceList[index].shop_rate *
              item.total_completed_services_qty;
          }
        } else if (this.parentData.data.serviceType == "2") {
          if (this.serviceList[index].discountStatus == 1) {
            this.newbookingData.price +=
              this.serviceList[index].virtual_discounted_amount *
              item.total_completed_services_qty;
          } else if (this.serviceList[index].discountStatus == 0) {
            this.newbookingData.price +=
              this.serviceList[index].virtual_rate *
              item.total_completed_services_qty;
          }
        }
        this.serviceList[index].toShow = false;
      }
    } else {
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      const index1 = this.parentData.data.bookingData.serviceInfo
        ? this.parentData.data.bookingData.serviceInfo.findIndex(
            (x: any) => x.serviceTypeHash == item.hash_id
          )
        : -1;
      this.serviceList[index].total_completed_services_qty = 1;
      this.serviceList[index].qty =
        index1 != -1
          ? this.parentData.data.bookingData.serviceInfo[index1].qty
          : 1;

      this.completedJobs.push(this.serviceList[index]);
      console.log(this.serviceList[index]);

      let service_cost;
      if (this.parentData.data.serviceType == "0") {
        if (this.serviceList[index].discountStatus == 1) {
          service_cost = this.serviceList[index].homeDiscountedPrice;
          // this.newbookingData.price += this.serviceList[index].homeDiscountedPrice
        } else if (this.serviceList[index].discountStatus == 0) {
          service_cost = this.serviceList[index].home_rate;
          // this.newbookingData.price += this.serviceList[index].home_rate
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.serviceList[index].discountStatus == 1) {
          service_cost = this.serviceList[index].shopDiscountedPrice;
          // this.newbookingData.price += this.serviceList[index].shopDiscountedPrice
        } else if (this.serviceList[index].discountStatus == 0) {
          service_cost = this.serviceList[index].shop_rate;
          // this.newbookingData.price += this.serviceList[index].shop_rate
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.serviceList[index].discountStatus == 1) {
          service_cost = this.serviceList[index].virtual_discounted_amount;
          // this.newbookingData.price += this.serviceList[index].shopDiscountedPrice
        } else if (this.serviceList[index].discountStatus == 0) {
          service_cost = this.serviceList[index].virtual_rate;
          // this.newbookingData.price += this.serviceList[index].shop_rate
        }
      }
      this.newbookingData.price += service_cost;
      this.serviceList[index].completed_by = [
        {
          cost: service_cost,
          employee_name:
            localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + "(Owner)",
          completed_by_hash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          competed_services_qty: 1,
        },
      ];
      this.serviceList[index].toShow = false;
    }
  }
  completedProducts: any = [];
  selectProducts(item: any) {
    console.log(item);
    // selecting from already added list item
    if (item.entity_product_hash) {
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash
      );
      if (index != -1) {
        this.productsList[index].current_status = 3;
        this.productsList[index].product_qty = item.product_qty;
        this.completedProducts.push(this.productsList[index]);

        if (this.parentData.data.serviceType == "0") {
          if (this.productsList[index].discount_status == 1) {
            this.newbookingData.price +=
              this.productsList[index].home_discounted_price * item.product_qty;
          } else if (this.productsList[index].discount_status == 0) {
            this.newbookingData.price +=
              this.productsList[index].home_price * item.product_qty;
          }
        } else if (this.parentData.data.serviceType == "1") {
          if (this.productsList[index].discount_status == 1) {
            this.newbookingData.price +=
              this.productsList[index].shop_discounted_price * item.product_qty;
          } else if (this.productsList[index].discount_status == 0) {
            this.newbookingData.price +=
              this.productsList[index].shop_price * item.product_qty;
          }
        } else if (this.parentData.data.serviceType == "2") {
          if (this.productsList[index].discount_status == 1) {
            this.newbookingData.price +=
              this.productsList[index].virtual_discounted_price *
              item.product_qty;
          } else if (this.productsList[index].discount_status == 0) {
            this.newbookingData.price +=
              this.productsList[index].virtual_price * item.product_qty;
          }
        }
        this.productsList[index].toShow = false;
      }
    } else {
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.parentData.data.bookingData.appointment_products ? this.parentData.data.bookingData.appointment_products.findIndex( (x:any)=>x.entity_product_hash == item.hash_id) : -1;
      this.productsList[index].product_qty = 1;
      // this.productsList[index].qty = index1 != -1  ? this.parentData.data.bookingData.serviceInfo[index1].qty : 1

      this.completedProducts.push(this.productsList[index]);

      let product_cost;
      if (this.parentData.data.serviceType == "0") {
        if (this.productsList[index].discount_status == 1) {
          product_cost = this.productsList[index].home_discounted_price;
          // this.newbookingData.price += this.productsList[index].homeDiscountedPrice
        } else if (this.productsList[index].discount_status == 0) {
          product_cost = this.productsList[index].home_price;
          // this.newbookingData.price += this.productsList[index].home_rate
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.productsList[index].discount_status == 1) {
          product_cost = this.productsList[index].shop_discounted_price;
          // this.newbookingData.price += this.productsList[index].shopDiscountedPrice
        } else if (this.productsList[index].discount_status == 0) {
          product_cost = this.productsList[index].shop_price;
          // this.newbookingData.price += this.productsList[index].shop_rate
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.productsList[index].discount_status == 1) {
          product_cost = this.productsList[index].virtual_discounted_price;
          // this.newbookingData.price += this.productsList[index].shopDiscountedPrice
        } else if (this.productsList[index].discount_status == 0) {
          product_cost = this.productsList[index].virtual_price;
          // this.newbookingData.price += this.productsList[index].shop_rate
        }
      }
      this.newbookingData.price += product_cost;
      //   this.productsList[index].completed_by = [{
      //     "cost": product_cost,
      //     "employee_name": localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + '(Owner)',
      //     "completed_by_hash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
      //     "competed_services_qty": 1
      // },]
      this.productsList[index].toShow = false;
    }
  }
  // removecompletedJobs(item:any){
  //   console.log(item);

  //   const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
  //   const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

  //   if(this.parentData.data.serviceType == '0'){
  //     if(this.completedJobs[index1].discountStatus == 1){
  //       this.newbookingData.price -= this.newbookingData[index1].homeDiscountedPrice
  //     }
  //     else if(this.completedJobs[index1].discountStatus == 0){
  //       this.newbookingData.price -= this.completedJobs[index1].home_rate
  //     }
  //   }
  //   else if(this.parentData.data.serviceType == '1'){
  //     if(this.completedJobs[index1].discountStatus == 1){
  //       this.newbookingData.price -= this.completedJobs[index1].shopDiscountedPrice
  //     }
  //     else if(this.completedJobs[index1].discountStatus == 0){
  //       this.newbookingData.price -= this.completedJobs[index1].shop_rate
  //     }
  //   }

  //   this.serviceList[index].toShow = true
  //   this.completedJobs.splice(index1,1)
  // }

  assignEmployee(item: any, index: any) {
    console.log(item);

    let dialogref = this._modelRef.open(EmployeeAssignForServiceComponent, {
      width: "600px",
      disableClose: true,
      data: {
        data: item,
        serviceType: this.parentData.data.serviceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.completedJobs[index] = res;

        if (!res.completed_by || res.completed_by.length == 0) {
          const index1 = this.serviceList.findIndex(
            (x: any) => x.hash_id == item.hash_id
          );
          this.serviceList[index1].toShow = true;
          this.completedJobs.splice(index, 1);
        }
        this.newbookingData.price = 0;
        this.completedJobs.forEach((element: any) => {
          element.completed_by.forEach((item: any) => {
            this.newbookingData.price += item.cost;
          });
        });
      }
    });
  }

  removeCompletedJobs(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.completedJobs.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    if (this.parentData.data.serviceType == "0") {
      if (this.completedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.completedJobs[index1].homeDiscountedPrice *
          this.completedJobs[index1].total_completed_services_qty;
      } else if (this.completedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.completedJobs[index1].home_rate *
          this.completedJobs[index1].total_completed_services_qty;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.completedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.completedJobs[index1].shopDiscountedPrice *
          this.completedJobs[index1].total_completed_services_qty;
      } else if (this.completedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.completedJobs[index1].shop_rate *
          this.completedJobs[index1].total_completed_services_qty;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.completedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.completedJobs[index1].virtual_discounted_amount *
          this.completedJobs[index1].total_completed_services_qty;
      } else if (this.completedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.completedJobs[index1].virtual_rate *
          this.completedJobs[index1].total_completed_services_qty;
      }
    }

    this.serviceList[index].toShow = true;
    this.completedJobs.splice(index1, 1);
  }
  removeCompletedProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.completedProducts.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    if (this.parentData.data.serviceType == "0") {
      if (this.completedProducts[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.completedProducts[index1].homeDiscountedPrice *
          this.completedProducts[index1].total_completed_services_qty;
      } else if (this.completedProducts[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.completedProducts[index1].home_rate *
          this.completedProducts[index1].total_completed_services_qty;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.completedProducts[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.completedProducts[index1].shopDiscountedPrice *
          this.completedProducts[index1].total_completed_services_qty;
      } else if (this.completedProducts[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.completedProducts[index1].shop_rate *
          this.completedProducts[index1].total_completed_services_qty;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.completedProducts[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.completedProducts[index1].virtual_discounted_amount *
          this.completedProducts[index1].total_completed_services_qty;
      } else if (this.completedProducts[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.completedProducts[index1].virtual_rate *
          this.completedProducts[index1].total_completed_services_qty;
      }
    }

    this.productsList[index].toShow = true;
    this.completedProducts.splice(index1, 1);
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  addOneHourAndFormat(date: Date): string {
    const newDate = new Date(date);
    newDate.setHours(date.getHours() + 1);

    const hours = newDate.getHours().toString().padStart(2, "0");
    const minutes = newDate.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): FormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as FormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }
  createFieldWithItem(item: any): FormGroup {
    const itemGroup = this.fb.group({
      name: [
        {
          item_name: item.item_name,
          item_desc: item.item_description,
          hash_id: item.inventory_item_hash,
          image_thumb_url: null,
        },
        Validators.required,
      ],
      price: [item.item_price, Validators.required],
      count: [item.item_qty, Validators.required],
      tax_slab: [item.tax_slab_hash ? item.tax_slab_hash : "default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300),
    //   filter((value) => typeof value === "string" && value.length > 2),
    //   switchMap((value) => this.fetchOptions(value))
    // );
    // this.filteredOptions.push(filteredOption);

    const priceControl = itemGroup.get("price") as FormControl;

    let previousPrice = item.item_price; // ✅ Correctly initialize with item price

    // ✅ Add item price once
    this.newbookingData.price += item.item_price;

    priceControl.valueChanges.subscribe((value) => {
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + parsedValue;
        previousPrice = parsedValue;
      }
    });

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // Get the form array of items
  get items(): FormArray {
    return this.form.get("items") as FormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.newbookingData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      console.log(currentItem.get("price")!.value);
      console.log(this.newbookingData.price);

      // this.newbookingData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    this.newbookingData = {
      price: 0,
    };
  }

  get formattedPrice(): string {
    return this.newbookingData.price?.toFixed(2);
  }

  set formattedPrice(value: string) {
    this.newbookingData.price = parseFloat(value);
  }
}
